module.exports = __webpack_public_path__ + "static/media/bag_icon.58e922ef.svg";